import { render } from "./ContatoView.vue?vue&type=template&id=4d739b85"
import script from "./ContatoView.vue?vue&type=script&lang=js"
export * from "./ContatoView.vue?vue&type=script&lang=js"

import "./ContatoView.vue?vue&type=style&index=0&id=4d739b85&lang=scss"

import exportComponent from "/home/runner/work/topnetms/topnetms/apps/topnetms_site_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__